import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function Neuron() {
    return (
        <DotLottieReact
            src="https://lottie.host/d9135ccf-507d-4710-b430-afb50600b2b1/9hekt5zpvr.lottie"
            loop
            autoplay
        />
    )
};

export default Neuron;